module.exports = __webpack_public_path__ + "static/media/pineappleSingle.58b810fb.JPG";